export default function RouteIcon(props) {
  return (
    <svg
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_7840_27512)">
        <path
          d="M5.33203 17.333V6.66634C5.33203 3.72101 7.72003 1.33301 10.6654 1.33301C13.6107 1.33301 15.9987 3.72101 15.9987 6.66634V25.333C15.9987 28.2783 18.3867 30.6663 21.332 30.6663C24.2774 30.6663 26.6654 28.2783 26.6654 25.333V14.6663"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33203 22.666H1.33203V30.666H9.33203V22.666Z"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.6641 1.33301H22.6641V9.33301H30.6641V1.33301Z"
          stroke="inherit"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7840_27512">
          <rect width="32" height="32" fill="inherit" />
        </clipPath>
      </defs>
    </svg>
  )
}
